import { render } from "./BasicModal1b.vue?vue&type=template&id=616e7a2e"
import script from "./BasicModal1b.vue?vue&type=script&lang=js"
export * from "./BasicModal1b.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__